import React, { memo, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v1 as uuidV1 } from 'uuid';
import { getTranslationAnswerByQuantity } from '../../../../shared/utils/smartutils';

const SummaryDescriptiveAnswer = ({ answer }) => {
  const htmlRef = useRef(null);
  const { question, chartData } = answer;

  const getTotalAnswered = () => {
    return question.numberOfAnswer;
  };

  const hasData = () => {
    return !!chartData && chartData.length;
  };

  const buildAnswered = () => {
    return (
      <>
        {hasData() &&
          chartData.map((item) => {
            return (
              <div key={uuidV1()} className="p-2 bg-white mb-2 text-justify">
                {item.descritiveAnswer}
              </div>
            );
          })}
      </>
    );
  };

  useEffect(() => {
    if (question && htmlRef) {
      htmlRef.current.innerHTML = question.description;
    }
  }, [question]);

  return (
    <div className="mb-3 bg-light p-3">
      <div ref={htmlRef} className="mb-3" />
      <div className="mb-3">
        {`${getTotalAnswered()} ${getTranslationAnswerByQuantity(
          getTotalAnswered()
        )}`}
      </div>
      {buildAnswered()}
    </div>
  );
};

SummaryDescriptiveAnswer.propTypes = {
  answer: PropTypes.shape({
    question: PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.number,
      numberOfAnswer: PropTypes.number,
      type: PropTypes.string,
    }),
    chartData: PropTypes.arrayOf(
      PropTypes.shape({
        descritiveAnswer: PropTypes.string,
        responsible: PropTypes.shape({
          fullName: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
};

export default withTranslation('common')(memo(SummaryDescriptiveAnswer));
